module.exports = __webpack_public_path__ + "static/media/pranav.1ec6ece5.png";